import { render } from "./PlatformDocSelect.vue?vue&type=template&id=e56dedf8"
import script from "./PlatformDocSelect.vue?vue&type=script&lang=js"
export * from "./PlatformDocSelect.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src710843524/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__